import { useEffect } from 'react';

// antd 모달 본문(.ant-modal-body)의 스크롤을 상단으로 되돌린다.
// 열림 모션이 시작된 뒤에야 레이아웃이 잡히므로 지연 후 초기화한다.
const useResetModalBodyScroll = (open: boolean) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      const scroll = document.querySelectorAll('.ant-modal-body');

      for (let i = 0; i < scroll.length; i += 1) {
        // Element.scrollTo는 레거시 Edge(EdgeHTML) 미지원 → scrollTop/scrollLeft 대입
        scroll[i].scrollTop = 0;
        scroll[i].scrollLeft = 0;
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [open]);
};

export default useResetModalBodyScroll;
